import { GridColumn } from '@bp/ui-components';
import { FragmentType, getFragmentData, graphql } from 'client/gql';
import { BpCard } from 'components/BpCard/BpCard';
import { UseCoursesTableFragment } from 'components/Courses/hooks/useCoursesTable';
import { CoursesPreviewTable } from 'components/Courses/tables/CoursesPreviewTable';
import { UseGroupsTableFragment } from 'components/Groups/hooks/useGroupsTable';
import { GroupsPreviewTable } from 'components/Groups/tables/GroupsPreviewTable';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const PreviewDataQueryDocument = graphql(`
  fragment PreviewDataQueryFields on Query {
    ...UseCoursesTableFields
    ...UseGroupsTableFields
  }
`);

type PreviewDataProps = {
  query?: FragmentType<typeof PreviewDataQueryDocument>;
};

export function PreviewData({ query }: PreviewDataProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const data = getFragmentData(PreviewDataQueryDocument, query);
  const coursesFragment = getFragmentData(UseCoursesTableFragment, data);
  const groupsFragment = getFragmentData(UseGroupsTableFragment, data);

  const handleCourseNavigate = (uuid: string) => {
    navigate('/courses/' + uuid);
  };

  const handleGroupNavigate = (uuid: string) => {
    navigate('/groups/' + uuid);
  };

  return (
    <GridColumn width={4}>
      <BpCard
        className='mb-7'
        fixedHeight='432px'
        noPadding
        canScroll
        header={{ headline: t('courses.title'), subHeadline: coursesFragment?.courses.length ?? 0 }}
      >
        <CoursesPreviewTable query={data} onNavigate={handleCourseNavigate} />
      </BpCard>
      <BpCard
        fixedHeight='432px'
        noPadding
        canScroll
        header={{ headline: t('groups.title'), subHeadline: groupsFragment?.groups?.length ?? 0 }}
      >
        <GroupsPreviewTable query={data} onNavigate={handleGroupNavigate} />
      </BpCard>
    </GridColumn>
  );
}
